import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';

const RecoverPasswordPage = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setIsLoading(true);
        setError('');
        setMessage('');
        try {
            await api.get('/api/users/recoverPassword/' + email);
            setMessage('Se l\'indirizzo email è corretto, riceverai un link per reimpostare la password.');
        } catch (err: any) {
            console.error("Errore nel recupero password", err);
            setError(err.response?.data?.message || 'Si è verificato un errore. Riprova più tardi.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-slate-900 flex flex-col justify-center items-center p-4">
            <div className="w-full max-w-md">
                <div className="text-center mb-8">
                    <div className="inline-block p-3 rounded-lg bg-sky-500 mb-4">
                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-white"><path d="M21.73 18a2.64 2.64 0 0 0-3.76 0l-1.18 1.18a2.64 2.64 0 0 0 0 3.76l3.76 3.76a2.64 2.64 0 0 0 3.76 0l1.18-1.18a2.64 2.64 0 0 0 0-3.76Z"/><path d="m11 2-3.05 3.05"/><path d="M14 5.05 11 8.05"/><path d="m7 8-3.05 3.05"/><path d="M11 12.05 8 15.05"/><path d="m7 15-3.05 3.05"/><path d="M3.05 11.95 0 15"/></svg>
                    </div>
                    <h1 className="text-3xl font-bold text-white">Recupera la tua password</h1>
                    <p className="text-slate-400 mt-2">Inserisci la tua email per ricevere le istruzioni.</p>
                </div>

                <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-8 shadow-lg">
                    {message ? (
                        <div className="text-center">
                            <p className="text-green-400">{message}</p>
                            <Link to="/login" className="mt-6 inline-block font-medium text-sky-400 hover:text-sky-300">
                                Torna al Login
                            </Link>
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit} className="space-y-6">
                            <div>
                                <label htmlFor="email" className="block text-sm font-medium text-slate-300 mb-2">Email</label>
                                <input
                                    id="email"
                                    type="email"
                                    value={email}
                                    onChange={e => setEmail(e.target.value)}
                                    placeholder="tu@email.com"
                                    required
                                    className="w-full bg-slate-800 border border-slate-600 rounded-lg px-4 py-3 text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-sky-500"
                                />
                            </div>
                            {error && (
                                <div className="text-red-400 text-sm text-center">{error}</div>
                            )}
                            <div>
                                <button
                                    type="submit"
                                    disabled={isLoading}
                                    className="w-full bg-sky-600 hover:bg-sky-500 text-white font-bold py-3 px-4 rounded-lg transition-colors duration-300 disabled:bg-slate-600 disabled:cursor-not-allowed"
                                >
                                    {isLoading ? 'Invio in corso...' : 'Invia link di recupero'}
                                </button>
                            </div>
                        </form>
                    )}
                </div>
                <div className="text-center mt-8 text-sm">
                    <span className="text-slate-400">Ricordi la password? </span>
                    <Link to="/login" className="font-medium text-sky-400 hover:text-sky-300">
                        Accedi
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default RecoverPasswordPage;